import { createI18n } from './i18n.js';

// Create and export the i18n instance
const i18n = createI18n();
export { i18n };

// Export the useTranslation hook for React components
export { useTranslation } from './useTranslation.js';

// Export language utilities
export { getCurrentLanguage, setLanguage, getAvailableLanguages } from './languageUtils.js';
